import React from 'react';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ListItem from '@material-ui/core/ListItem';

import { getIndicatorColor } from '../../common/global';
import styles from './Virtual.module.scss';

export default class Virtual extends React.Component {
  onSelectVirtual = () => {
    const { onSelectVirtualFunc, virtual } = this.props;
    onSelectVirtualFunc(virtual);
  };
  render() {
    const { virtual = {} } = this.props;
    const { name = '', status = '', note = {} } = virtual;

    let privateNote = '';
    try {
      privateNote = note.private || '';
    } catch (error) {
      // console.error("Private note doesn't exist");
    }

    // Component-connected virtual experiences have a component in place of a product.
    // Showing what it is connected to is how ops tell similarly-named ones apart.
    const connectionName = virtual.component?.title || virtual.product?.name || '';

    let borderLeftStyle = `3px solid ${getIndicatorColor(status)}`;

    return (
      <ListItem
        className={styles.root}
        style={{ borderLeft: borderLeftStyle }}
        onClick={this.onSelectVirtual}
      >
        <div className={styles.virtual}>
          <div>
            <span className={styles.boldFont}>{name}</span>
            <br />
            {connectionName ? (
              <React.Fragment>
                {connectionName}
                <br />
              </React.Fragment>
            ) : null}
            <span>{privateNote}</span>
          </div>
          <div>
            <AddCircleOutlineIcon />
          </div>
        </div>
      </ListItem>
    );
  }
}
